import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LandingPage } from './components/LandingPage';
import { CheckoutPage } from './components/CheckoutPage';
import { PaymentSuccessPage } from './components/PaymentSuccessPage';
import { PaymentCancelPage } from './components/PaymentCancelPage';
import App from './App';

function MainRouter() {
  return (
    <HashRouter>
      <Routes>
        {/* Public Landing Page */}
        <Route path="/" element={<LandingPage />} />
        
        {/* Payment Routes */}
        <Route path="/checkout/app-mobile" element={
          <CheckoutPage packageId="app_mobile" packageName="App Móvil" price="3/mes" />
        } />
        <Route path="/checkout/web-platform" element={
          <CheckoutPage packageId="web_platform" packageName="Plataforma Web" price="2500" />
        } />
        <Route path="/payment/success" element={<PaymentSuccessPage />} />
        <Route path="/payment/cancel" element={<PaymentCancelPage />} />
        
        {/* All other routes go to App (which has its own routing) */}
        <Route path="/*" element={<App />} />
      </Routes>
    </HashRouter>
  );
}

export default MainRouter;
